import React from 'react';
import CollapsibleNotificationItem from './CollapsibleNotificationItem';

/**
 * NotificationItem Component
 * Displays a single notification with read/unread state and actions
 * Now uses CollapsibleNotificationItem for consistency
 */
const NotificationItem = ({ 
  notification, 
  onMarkAsRead, 
  onDismiss,
  onAction 
}) => {
  const handleClick = () => {
    if (onAction) {
      onAction(notification);
    }
    if (!notification.is_read && onMarkAsRead) {
      onMarkAsRead(notification.id);
    }
  };

  return (
    <div onClick={handleClick} className="cursor-pointer">
      <CollapsibleNotificationItem
        notification={notification}
        borderColor="blue"
        badgeVariant="info"
      >
        {onDismiss && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDismiss(notification.id);
            }}
            className="text-text-muted hover:text-text-secondary"
            aria-label="Dismiss notification"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </CollapsibleNotificationItem>
    </div>
  );
};

export default NotificationItem;

